import { DomainError } from "../errors/DomainError";

export type BookingCode = string;

export class InvalidBookingCodeError extends DomainError {
  constructor() {
    super("El código de reserva no puede estar vacío");
    this.name = "InvalidBookingCodeError";
  }
}

export const createBookingCode = (raw: string): BookingCode => {
  if (!raw) {
    throw new InvalidBookingCodeError();
  }

  return raw;
};
